import { memo as Memo, useMemo, useEffect } from 'react'

//* HOCs
import { useRouter } from 'next/router'

//* Components
import { NextSeo } from 'next-seo'

//* Context
import { withUIContext } from 'context'

//* Styles
import PageStyle from './style'

const Page = Memo(({ winWidth, meta, ...props }) => {
	//! Router
	const router = useRouter()

	//! URL
	const url = useMemo(() => process.env.host + (router.locale !== 'en' ? '/' + router.locale : '') + router.asPath, [router])

	//! Description
	const description = useMemo(() => meta?.description || 'Ng slot meta description', [meta?.description])

	//! Title
	const title = useMemo(() => meta?.title || 'Ng slot', [meta?.title])

	useEffect(() => {
		window.history.scrollRestoration = 'manual'
	}, [])

	return (
		<>
			<NextSeo
				title={title}
				description={description}
				canonical={url}
				type='website'
				additionalMetaTags={[
					{
						name: 'keywords',
						content: meta?.keywords,
					},
				]}
				openGraph={{
					url: url,
					title: title,
					description: description,
					images: [{ url: meta?.image || process.env.host + '/images/logo.svg', alt: title }],
				}}
				twitter={{
					handle: '@handle',
					site: '@site',
					cardType: 'summary_large_image',
				}}
			/>

			<PageStyle style={props.style} className={props.className}>
				{props.children}
			</PageStyle>
		</>
	)
})

export default withUIContext(Page, ['winWidth'])
